import { LoginService } from '../services/LoginService';
import { PushNotificationService } from '../services/PushNotificationService';
import { config, getApiUrl } from '@/config';
import { StaffCollection } from '@/viewmodels/Staff';
import { ProductCollection } from '@/viewmodels/Product';
import { PromotionCollection } from '@/viewmodels/Promotion';
import { CustomerCollection } from '@/viewmodels/Customer';
import { CategoryCollection } from '@/viewmodels/Category';
import { RestaurantCollection } from '@/viewmodels/Restaurant';
import { TableCollection } from '@/viewmodels/Table';
import { OrderCollection, CurrentOrderCollection } from '@/viewmodels/Order';
import { UploadService } from '@/services/UploadService';
import { ReportService } from '@/services/ReportService';
import { LayoutService } from '@/services/LayoutService';
import { TipCollection } from '@/viewmodels/Tip';

export class Application {
    public readonly loginService: LoginService = new LoginService(this, config.baseUrl);
    public readonly layoutService: LayoutService = new LayoutService(config.baseUrl);

    public readonly pushNotificationService: PushNotificationService = new PushNotificationService(config.baseUrl);
    public readonly uploadService: UploadService = new UploadService(config.baseUrl);
    public readonly reportService: ReportService = new ReportService(config.baseUrl);

    public readonly _staffCollection: StaffCollection = new StaffCollection();
    public readonly _categoryCollection: CategoryCollection = new CategoryCollection();
    public readonly _customerCollection: CustomerCollection = new CustomerCollection();
    public readonly _productCollection: ProductCollection = new ProductCollection();
    public readonly _restaurantCollection: RestaurantCollection = new RestaurantCollection();
    public readonly _tableCollection: TableCollection = new TableCollection();
    public readonly _orderCollection: OrderCollection = new OrderCollection();
    public readonly _currentOrderCollection: CurrentOrderCollection = new CurrentOrderCollection();
    public readonly _promotionCollection: PromotionCollection = new PromotionCollection();
    public readonly _tipCollection: TipCollection = new TipCollection();


    public get staffCollection(): StaffCollection {
        return this._staffCollection;
    }

    public get categoryCollection(): CategoryCollection {
        return this._categoryCollection;
    }

    public get customerCollection(): CustomerCollection {
        return this._customerCollection;
    }

    public get productCollection(): ProductCollection {
        return this._productCollection;
    }

    public get promotionCollection(): PromotionCollection {
        return this._promotionCollection;
    }

    public get restaurantCollection(): RestaurantCollection {
        return this._restaurantCollection;
    }

    public get tableCollection(): TableCollection {
        return this._tableCollection;
    }

    public get orderCollection(): OrderCollection {
        return this._orderCollection;
    }

    public get currentOrderCollection(): CurrentOrderCollection {
        return this._currentOrderCollection;
    }

    public get tipCollection(): TipCollection {
        return this._tipCollection;
    }


    constructor() {
        this.refreshData();
    }

    public refreshData() {
        this.staffCollection.fetchData().catch(e => console.log("Failed to load staff", e));
        this.categoryCollection.fetchData().catch(e => console.log("Failed to load categories", e));
        this.customerCollection.fetchData().catch(e => console.log("Failed to load customers", e));
        this.productCollection.fetchData().catch(e => console.log("Failed to load products", e));
        this.restaurantCollection.fetchData().catch(e => console.log("Failed to load restaurants", e));
        this.tableCollection.fetchData().catch(e => console.log("Failed to load tables", e));
        this.orderCollection.fetchData().catch(e => console.log("Failed to load orders", e));
        this.currentOrderCollection.fetchData().catch(e => console.log("Failed to load current orders", e));
        this.promotionCollection.fetchData().catch(e => console.log("Failed to load promotions", e));
        this.tipCollection.fetchData().catch(e => console.log("Failed to load tips", e));
    }

    public onLogin() {
        this.refreshData();
    }
}

export const app = new Application();
